module.exports = __webpack_public_path__ + "img/01.fea4f9f3.png";